import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_DEVICE_PRESET_BY_ID } from './actionTypes';
import { getDmxDevicePresetByIdSuccess, getDmxDevicePresetByIdError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getDevicePresetById({ payload: { user, deviceId, presetId } }) {
  try {
    const response = yield call(dmxAPI.getDevicePreset, user.token, deviceId, presetId);
    yield put(getDmxDevicePresetByIdSuccess(response));
  } catch (error) {
    yield put(getDmxDevicePresetByIdError(error));
  }
}

export function* watchGetDmxDevicePresetById() {
  yield takeEvery(GET_DMX_DEVICE_PRESET_BY_ID, getDevicePresetById);
}

function* getDmxDevicePresetByIdSaga() {
  yield all([fork(watchGetDmxDevicePresetById)]);
}

export default getDmxDevicePresetByIdSaga;
